import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const CardSelectedDesign = ({product = {}}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Box {...styles.rightBox.cardSelectedDesign}>
            <Text {...styles.rightBox.label}>
                <FormattedMessage id="eGiftcard.product.design" defaultMessage="Design" />
            </Text>
            <Text {...styles.rightBox.value}>{product?.name}</Text>
        </Box>
    )
}

CardSelectedDesign.propTypes = {
    product: PropTypes.object
}

export default CardSelectedDesign
